import { Effect } from "babylonjs/Materials/effect";

let name = 'handlePixelShader';
let shader = `uniform vec3 color;
void main(void) {
gl_FragColor=vec4(color,1.0);
}`;

Effect.ShadersStore[name] = shader;
/** @hidden */
export var handlePixelShader = { name, shader };
